import { render, staticRenderFns } from "./Billplz.vue?vue&type=template&id=2cff31e9&scoped=true&"
import script from "./Billplz.vue?vue&type=script&lang=js&"
export * from "./Billplz.vue?vue&type=script&lang=js&"
import style0 from "./Billplz.vue?vue&type=style&index=0&id=2cff31e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff31e9",
  null
  
)

export default component.exports